import { useAccount } from './account';
import { useLibrary } from './library';
import { usePlanner } from './planner';
import { useShopping } from './shopping';
import { useProgress } from './progress';
import { useSettings } from './settings';
import { useSocial } from './social';
import { useFriends } from './friends';
import { useCloud, waitForCloudIdle } from './cloud';
import { usePlan } from './plan';
import { useTimers } from './timers';
import { mmkv } from './storage';
import { eraseLocalPhotos } from '../platform/media';
/** Called only after confirmed server account deletion. Sign-out alone preserves local recipes. */
export async function eraseAccountOnThisDevice(): Promise<void> {
  useAccount.setState({ user: null, codes: null, recovered: false }); // stop new account syncs first
  await waitForCloudIdle();
  for (const timer of useTimers.getState().timers)
    useTimers.getState().cancel(timer.id);
  useLibrary.setState(useLibrary.getInitialState(), true);
  usePlanner.setState(usePlanner.getInitialState(), true);
  useShopping.setState(useShopping.getInitialState(), true);
  useProgress.setState(useProgress.getInitialState(), true);
  useSettings.setState(useSettings.getInitialState(), true);
  useSocial.getState().forget();
  useFriends.getState().forget();
  useCloud.setState({
    accountId: null,
    lastSyncAt: null,
    status: 'off',
    error: null,
  });
  usePlan.setState(usePlan.getInitialState(), true);
  mmkv.clearAll();
  await eraseLocalPhotos();
}
